import { Component, OnInit } from '@angular/core';
import { UserModel } from '../../../authentication/models/user.model';
import { UserService } from '../../../authentication/services/user.service';
import { RouteService } from '../../../routing/services/route.service';

@Component({
    selector: 'chassis-users-index',
    templateUrl: './index.page.html',
    styleUrls: ['./index.page.scss']
})
export class UserIndexPage implements OnInit {

    protected title = 'Users';

    protected routePrefix = 'users';

    protected pluginPrefix = 'chassis-users';

    public model: UserModel;

    protected table: any = {
        service: null,
    };

    constructor(
        protected userService: UserService,
        protected routeService: RouteService,
    ) {
        //
    }

    public ngOnInit(): void {
        this.createDatatable();
    }

    protected createDatatable(): void {
        this.table = {
            service: this.userService,
            callbacks: {
                click: (user) => {
                    // You can't open deleted users.
                    if (user.deleted_at) {
                        return;
                    }

                    this.routeService.navigate(
                        `${this.routePrefix}.edit`,
                        [user.id]
                    );
                },
            },
        };
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/users/index/index.page.ts